import { create } from 'zustand';
import { apiClient } from '../services/api/client';

export interface FeatureFlags {
  data_library: boolean;
  attendance_follow_ups: boolean;
  multi_modality: boolean;
  matching_server_integration: boolean;
  live_session_delivery: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  data_library: false,
  attendance_follow_ups: false,
  multi_modality: false,
  matching_server_integration: false,
  live_session_delivery: false,
};

interface FeatureFlagState {
  flags: FeatureFlags;
  isLoaded: boolean;
  fetchFlags: () => Promise<void>;
}

export const useFeatureFlagStore = create<FeatureFlagState>()((set) => ({
  flags: DEFAULT_FLAGS,
  isLoaded: false,

  fetchFlags: async () => {
    try {
      const flags = await apiClient.get<FeatureFlags>('/api/feature-flags');
      set({ flags, isLoaded: true });
    } catch {
      // On error, keep defaults (all flags off) — fail closed
      set({ isLoaded: true });
    }
  },
}));

/**
 * Hook to check if a feature flag is enabled.
 * Returns false until flags are loaded (fail closed).
 */
export function useFeatureFlag(flag: keyof FeatureFlags): boolean {
  const { flags, isLoaded } = useFeatureFlagStore();
  if (!isLoaded) return false;
  return flags[flag];
}
